import { IAdvertiserGridRow } from '@/Interfaces/Advertiser.interface';
import TvFilledIcon from '@/components/Icons/TvFilledIcon';
import { Chip, styled } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

const ClientChip = styled(Chip)(({ theme }) => ({
  maxHeight: '29px',
  borderRadius: '32px',
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: 12,
  '& .tv-filled-icon': {
    margin: '0 -8px -2px 10px',
    color: theme.palette.primary.dark,
    width: 13,
  },
}));

const ClientCell = ({ value }: GridRenderCellParams<IAdvertiserGridRow>) => {
  return (
    <div className='overflow-hidden'>
      {value ? <ClientChip icon={<TvFilledIcon />} variant='outlined' label={value?.label} /> : '-'}
    </div>
  );
};

export default ClientCell;
